import ajax from '../util/ajax';

export function login(passowrd) {
    return ajax({
        url: '/scimallH5/dxsxsdt/login',
        method: 'POST',
        data: {
            passowrd: passowrd
        }
    });
}